export class Token {
  token:string;
  refresh_token:string;
  data:{
    name:string,
    roles:string[]
  };
}
